const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.' , sortable: false, thStyle: 'width: 5%', },
    { key: 'is_alive', label: 'Status' , thStyle: 'width: 10%'},
    { key: 'mode', label: 'Recently Mode', thStyle: 'width: 10%' },
    { key: 'server', label: 'Server' }, // name[host]@ip_addr(version)
    { key: 'nickname', label: 'Nickname' },
    { key: 'domain', label: 'Domain', thStyle: 'width: 20%'},
    // { key: 'select', label: 'Detail' },
  ],
  KO : [
    { key: 'id', label: 'No.' , sortable: false, thStyle: 'width: 5%', },
    { key: 'is_alive', label: '상태' , thStyle: 'width: 10%'},
    { key: 'mode', label: '최근 적용 모드', thStyle: 'width: 10%' },
    { key: 'server', label: '서버' }, // name[host]@ip_addr(version)
    { key: 'nickname', label: '이름' },
    { key: 'domain', label: '도메인', thStyle: 'width: 20%'},
    // { key: 'select', label: '상세' },
  ],
  JP: [
    { key: 'id', label: 'No.' , sortable: false, thStyle: 'width: 5%', },
    { key: 'is_alive', label: 'ステータス' , thStyle: 'width: 10%'},
    { key: 'mode', label: '最新モード', thStyle: 'width: 10%' },
    { key: 'server', label: 'サーバー' }, // name[host]@ip_addr(version)
    { key: 'nickname', label: 'ニックネーム' },
    { key: 'domain', label: 'ドメイン', thStyle: 'width: 20%'},
    // { key: 'select', label: '詳細' },
  ]
}

const domain_manage_fields = {
  EN:[
    { key: 'domain', thStyle: 'width: 10%', },
    { key: 'mode', thStyle: 'width: 5%', },
    { key: 'level', thStyle: 'width: 5%', },
  ],
  KO:[
    { key: 'domain', thStyle: 'width: 10%', },
    { key: 'mode', thStyle: 'width: 5%', },
    { key: 'level', thStyle: 'width: 5%', },
  ],
  JP:[
    { key: 'domain', thStyle: 'width: 10%', },
    { key: 'mode', thStyle: 'width: 5%', },
    { key: 'level', thStyle: 'width: 5%', },
  ]
}

const fields = {
  i18n_fields,
  domain_manage_fields
}

export default fields